import app from "../_app";

const nav = document.querySelector('.js-navigation');

if(nav) {
    const initNavigation = () =>  {
        document.querySelectorAll('.js-nav').forEach((nav, i) => {
            const navItems = nav.querySelectorAll('.js-nav-item');
            const navSubItems = nav.querySelectorAll('.js-nav-subitem');
            const breadCrumbsBack = document.querySelectorAll('.js-menu-backlink');
            const subsubitemsContainer = document.querySelectorAll('.js-nav-subsubitems-container');
            const navBg = document.querySelector('.js-nav-bg');
            const body = document.body;

            body.setAttribute('data-loaded', '');

            if (app.viewport.isEqualOrGreaterThan('lg')) {
                navItems.forEach((navItem) => {
                    navItem.addEventListener('mouseenter', (e) => {
                        //body.classList.add('nav--open');
                        navBg.classList.add('active');
                    });

                    navItem.addEventListener('mouseleave', () => {
                        if (!window.location.hash.includes('#sqr:')) {
                            app.unlockBody();
                        }
                        //body.classList.remove('nav--open');
                        navBg.classList.remove('active');
                    });
                });

                navSubItems.forEach((navSubItem) => {
                    navSubItem.addEventListener('mouseenter', (e) => {
                        const currentNavSubItem = e.currentTarget;

                        currentNavSubItem.closest('.js-nav-subitems-container').querySelectorAll('.js-nav-subsubitems').forEach((subsubItem) => {
                            subsubItem.classList.remove('d-lg-block');
                        });

                        if(currentNavSubItem.hasAttribute('data-id')) {
                            document.querySelector(`.js-nav-subsubitems[data-id="${currentNavSubItem.dataset.id}"]`).classList.add('d-lg-block');
                        }

                        currentNavSubItem.classList.add('nav__subitem--active');
                        currentNavSubItem.closest('.js-nav-item').querySelectorAll('.js-nav-subitem').forEach((item) => {
                            if (item !== currentNavSubItem) {
                                item.classList.remove('nav__subitem--active');
                            }
                        });




                    });
                });
            } else {
                const navTriggers = document.querySelectorAll('.js-nav-trigger');
                const navBack = document.querySelector('.js-nav-back');
                let depth = 0;

                navBack.style.display = 'none';
                navItems.forEach(item => item.classList.remove('nav__item--active'));
                navSubItems.forEach(item => item.classList.remove('nav__subitem--active'));

                const navMoveNavigation = (newDepth) => {
                    depth = newDepth;
                    navBack.style.display = depth === 0 ? 'none' : '';
                    nav.setAttribute('data-depth', depth);
                };

                navTriggers.forEach((navTrigger) => {
                    navTrigger.addEventListener('click', () => {
                        if (body.classList.contains('nav--open')) {
                            navMoveNavigation(0);
                            navItems.forEach(item => item.classList.remove('nav__item--active'));
                            navSubItems.forEach(item => item.classList.remove('nav__subitem--active'));
                            subsubitemsContainer.forEach(item => item.classList.remove('active'));
                            document.querySelectorAll('.js-nav-subsubitems').forEach(item => item.classList.remove('d-block'));
                            body.classList.remove('nav--open');
                            app.unlockBody();
                        } else {
                            if (document.body.hasAttribute('data-search')) {
                                document.querySelector('.js-searchform-overlay').dispatchEvent(new Event('click'));
                            }
                            app.lockBody();
                            body.classList.add('nav--open');
                            if (navSubItems[0].classList.contains('js-depth-2')) {
                                navMoveNavigation(2);
                                navSubItems[0].classList.add('nav__subitem--active');
                                navSubItems[0].closest('.js-nav-item').classList.add('nav__item--active');
                            } else if (navItems[0].classList.contains('js-depth-1')) {
                                navMoveNavigation(1);
                                navItems[0].classList.add('nav__item--active');
                            }
                        }
                    });
                });

                document.querySelectorAll('.js-nav-back').forEach((backButton) => {
                    backButton.addEventListener('click', () => {
                        let newDepth = depth - 1;

                        if (newDepth <= 0) {
                            newDepth = 0;
                            navItems.forEach(item => item.classList.remove('nav__item--active'));
                        }

                        if (newDepth === 1) {
                            navSubItems.forEach(item => item.classList.remove('nav__subitem--active'));
                        }

                        document.querySelectorAll('.js-nav-subsubitems').forEach(item => item.classList.remove('d-block'));
                        subsubitemsContainer.forEach(item => item.classList.remove('active'));

                        navMoveNavigation(newDepth);
                    });
                });

                navItems.forEach((navItem) => {
                    navItem.querySelector('a').addEventListener('click', (e) => {
                        e.preventDefault();
                        navItem.classList.add('nav__item--active');
                        const subitemsContainer = navItem.querySelector('.js-nav-subitems-container');
                        if (subitemsContainer) subitemsContainer.scrollTop = 0;
                        navMoveNavigation(1);
                    });
                });

                navSubItems.forEach((navSubItem) => {
                    navSubItem.querySelector('a').addEventListener('click', (e) => {
                        if (navSubItem.classList.contains('nav__subitem--subs') && navSubItem.hasAttribute('data-id')) {
                            e.preventDefault();

                            // Scroll the parent subitems-container to top so level 3 is visible from the top
                            const parentContainer = navSubItem.closest('.js-nav-subitems-container');
                            if (parentContainer) parentContainer.scrollTop = 0;

                            subsubitemsContainer.forEach(item => {
                                item.classList.add('active');
                                item.scrollTop = 0;
                            });
                            const targetWrapper = document.querySelector(`.js-nav-subsubitems[data-id="${navSubItem.dataset.id}"]`);
                            targetWrapper.classList.add('d-block');
                            targetWrapper.scrollTop = 0;
                            navSubItem.classList.add('nav__subitem--active');
                            navMoveNavigation(2);
                        }
                    });
                });

                document.querySelectorAll('.js-show-parent').forEach((item) => {
                    item.parentElement.classList.add('d-block', 'd-lg-none');
                });

                breadCrumbsBack.forEach((backLink) => {
                    backLink.addEventListener('click', (e) => {
                        if (app.getCookie('user_navigated')) {
                            e.preventDefault();
                            navTrigger.click();
                        }
                    });
                });

                document.querySelectorAll('.js-goto-select').forEach(function (select) {
                    select.addEventListener('change', function () {

                        const selectedOption = select.options[select.selectedIndex];
                        const hreflang = selectedOption.dataset.hreflang;
                        const alternate = document.querySelector('link[rel="alternate"][hreflang="' + hreflang + '"]');
                        const alternatelink = alternate.getAttribute('href');
                        if(alternatelink) {
                            window.location.href = alternatelink;
                        }
                    });
                });

            }
        });

        let lastScrollPosition = 0;

        window.addEventListener("scroll", () => {
            const nav = document.querySelector('.js-nav');
            let scrollY = window.scrollY;

            if (scrollY > lastScrollPosition && lastScrollPosition > 0) {
                nav.classList.add("hide");
            } else {
                nav.classList.remove("hide");
            }

            lastScrollPosition = scrollY;
        });
    };


    async function fetchNavigation() {

        const language = document.documentElement.dataset.lang;

        try {
            const response = await fetch(`/?section_id=navigation-ajax`);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const navigationElement = document.querySelector('.js-navigation');

            navigationElement.innerHTML = doc.querySelector('.js-nav-data').innerHTML;

            initNavigation();

        } catch (error) {
            console.error(error);
        }
    }
    fetchNavigation();
}
